import React, { useState, useEffect, useContext } from 'react'
import { useGate } from 'statsig-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { Drawer, Button, Input, message, Steps, Radio, Checkbox, Divider, Space, Typography } from 'antd'
import { Alert } from '@mercadoni/gungnir'
import * as dayjs from 'dayjs'
import {
  getSlotsAvailabilityRescheduleDeprecated,
  getSlotsAvailabilityRescheduleV1,
  createReschedule,
  getReasons
} from '../../flag-management.services'
import Icons from '@commonComponents/Icons'
import { useTranslation } from 'react-i18next'
import Moment from 'react-moment'
import * as moment from 'moment'
import { REASON_PARAMS } from '../../../../utils/constants'
import { calculateDifferenceOfHours } from '../../../../utils/dates'
import { getJob } from '../../../jobs/jobs.services'
import { HistoricalContext } from '../../../../refactory/modules/jobs/infrastructure/job-detail/historical.context'

const { v4: uuidv4 } = require('uuid')

const { Step } = Steps
const { TextArea } = Input
const { Title } = Typography

const JobReschedule = Form.create()(
  ({ jobId, handleJobReschedule, visible, job, setSelectedJob, jobsSearch, setJob }) => {
    const { t } = useTranslation()
    const [current, setCurrent] = useState(0)
    const [slots, setSlots] = useState([])
    const [staticSlots, setStaticSlots] = useState([])
    const [expressSlots, setExpressSlots] = useState([])
    const [newStructureSlots, setNewStructureSlots] = useState(false)
    const [selectedSlot, setSelectedSlot] = useState()
    const [comment, setComment] = useState('')
    const [textAreaLength, setTextAreaLength] = useState(0)
    const [resetSteps, setResetSteps] = useState(false)
    const [loading, setLoading] = useState(false)
    const [rescheduleReasonId, setRescheduleReasonId] = useState(null)
    const [rescheduleReasons, setRescheduleReasons] = useState([])
    const [isReasonOpen, setIsReasonOpen] = useState(false)
    const { getJobHistorical } = useContext(HistoricalContext)
    const isGetDetailJobByNebulaActive = useGate('is_get_detail_job_by_nebula_active').value

    const steps = [
      {
        description: t('jobs.jobReschedule.delivery-time'),
        content: 'delivery-content'
      },
      {
        description: t('jobs.jobReschedule.comment'),
        content: 'comment-content'
      }
    ]

    const next = () => {
      setCurrent(current + 1)
    }

    const prev = () => {
      setCurrent(current - 1)
    }

    const sendReschedule = async () => {
      const id = uuidv4()
      setLoading(true)
      try {
        let slot
        if (newStructureSlots) {
          slot = expressSlots.find((s) => s.id === selectedSlot)
          if (!slot) {
            slot = staticSlots.find((s) => s.id === selectedSlot)
          }
        } else {
          slot = slots.find((s) => s.id === selectedSlot)
        }
        await createReschedule(
          jobId,
          slot,
          comment,
          resetSteps,
          rescheduleReasonId,
          REASON_PARAMS.RESCHEDULE,
          id,
          isReasonOpen
        )
        setLoading(false)
        handleJobReschedule()
        if (isGetDetailJobByNebulaActive) {
          if (jobsSearch) {
            setSelectedJob()
          }
          cleanFields()
        } else {
          getJobHistorical(jobId)
          setTimeout(async () => {
            if (jobsSearch) {
              const response = await getJob(jobId)
              setSelectedJob(response)
              setJob(response)
            }
            cleanFields()
          }, 3000)
        }
        message.success(t('jobs.jobReschedule.reschedule'))
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }

    const closeJobRescheduleDrawer = () => {
      setExpressSlots([])
      setStaticSlots([])
      setSlots([])
      setNewStructureSlots(false)
      handleJobReschedule()
    }

    const cleanFields = () => {
      setCurrent(0)
      setSelectedSlot(null)
      setNewStructureSlots(false)
      setComment('')
      setExpressSlots([])
      setStaticSlots([])
      setSlots([])
      setRescheduleReasonId(null)
      setIsReasonOpen(false)
    }

    const onSelectedSlot = ({ target: { value } }) => {
      setSelectedSlot(value)
    }

    const onChangeComment = ({ target: { value } }) => {
      setComment(value)
      setTextAreaLength(value.length)
    }

    const validateOperationModelForResetSteps = (operationModel) => {
      return (
        [
          'PICK_AND_DELIVERY_WITH_STORAGE',
          'PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER',
          'ZONE_PICKING_AND_DELIVERY_WITH_STORAGE'
        ].indexOf(operationModel.toString()) >= 0
      )
    }

    const validateStepsForResetSteps = (tasks) => {
      let proccessingValidator = 0
      for (let index = 0; index < tasks.length; index++) {
        if (
          (tasks[index].name === 'PICK_UP_FOR_DELIVERY' || tasks[index].name === 'DELIVERY_WITH_STORAGE') &&
          tasks[index].status === 'DOING'
        )
          proccessingValidator = ++proccessingValidator
      }
      return proccessingValidator > 0
    }

    let stylesheet = document.styleSheets[0]

    const getReasonTitle = (id) => {
      let reason = rescheduleReasons.find((obj) => obj.id === id)
      return reason.title
    }
    const getReasonStatus = (id) => {
      let reason = rescheduleReasons.find((obj) => obj.id === id)
      return reason.metadata.openQuestion
    }

    const onChangeReason = (e) => {
      setComment(getReasonTitle(e.target.value))
      setIsReasonOpen(getReasonStatus(e.target.value))
      setRescheduleReasonId(e.target.value)
      setTextAreaLength(0)
    }

    const onChangeCheckBox = () => {
      setResetSteps(!resetSteps)
      resetSteps === false
        ? stylesheet.insertRule('.ant-checkbox-wrapper{ background-color: #F0F0F0}', 0)
        : stylesheet.deleteRule('.ant-checkbox-wrapper{ background-color: #F0F0F0}', 0)
    }

    const drawExpressSlots = (currentTimeZone) => {
      return (
        <React.Fragment>
          {expressSlots.map((slot) => {
            return (
              <div key={slot.id}>
                <Radio value={slot.id}>
                  <div>
                    <span className='secondary-text'>
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.from}
                      </Moment>{' '}
                      -
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.to}
                      </Moment>
                    </span>{' '}
                    <span className='tag-differecen-hours'>{calculateDifferenceOfHours(slot.from, slot.to)} min</span>
                  </div>
                </Radio>
              </div>
            )
          })}
        </React.Fragment>
      )
    }

    const drawStaticSlots = (currentTimeZone, staticSlots) => {
      let currentDate = true

      return (
        <React.Fragment>
          {staticSlots.map((slot) => {
            let dateCategory
            if (currentDate !== moment(slot.from).format('dddd D MMMM')) {
              dateCategory = (
                <React.Fragment>
                  <p className='secondary-text title-slot-reschedule'>
                    <Moment format='dddd D MMMM' tz={currentTimeZone}>
                      {slot.to}
                    </Moment>
                  </p>
                </React.Fragment>
              )
              currentDate = moment(slot.from).format('dddd D MMMM')
            }
            return (
              <div key={slot.id}>
                {dateCategory}
                <Radio value={slot.id}>
                  <React.Fragment>
                    <span className='secondary-text'>
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.from}
                      </Moment>{' '}
                      -
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.to}
                      </Moment>
                    </span>
                  </React.Fragment>
                </Radio>
              </div>
            )
          })}
        </React.Fragment>
      )
    }

    const listSlotDeliveryTime = () => {
      const userInfo = JSON.parse(localStorage.getItem('user_info'))
      const currentTimeZone = job.storeTimezone ? job.storeTimezone : userInfo.user.client.timeZone
      const slotTimes = newStructureSlots ? staticSlots : slots

      return (
        <>
          <label className='step-title-reschedule'>{t('setANewDeliverySchedule')}</label>
          <label className='step-description-reschedule'>{t('jobs.jobReschedule.form.list-delivery-time')}</label>

          <div className='div-alert-message-slots'>
            <label>
              <Icons iconName='Warning' /> {t('warningAlerMessageForSlots')}
            </label>
          </div>

          <Radio.Group defaultValue={selectedSlot} onChange={onSelectedSlot}>
            {newStructureSlots && expressSlots.length ? (
              <>
                <label className='step-title-reschedule'>
                  <Icons iconName='SlotExpress' /> {t('express')}
                </label>
                <div className='content-slots'>{drawExpressSlots(currentTimeZone)}</div>
              </>
            ) : null}

            <label className='step-title-reschedule'>
              <Icons iconName='SlotCalendar' /> {t('scheduled')}
            </label>
            <div className='content-slots'>{drawStaticSlots(currentTimeZone, slotTimes)}</div>
          </Radio.Group>
        </>
      )
    }
    const isNextDisabled = (step) => {
      let disabled = true
      if (step === 'delivery-content') {
        disabled = !selectedSlot
      }

      if (rescheduleReasonId !== 0) {
        disabled = false
      }
      if (step === 'comment-content') {
        disabled = (isReasonOpen && textAreaLength < 5) || rescheduleReasonId === null
      }
      return disabled
    }

    const rescheduleReasonsBanner = (
      <div className='reschedule-reasons-banner'>
        <div className='reschedule-reasons-icon-banner'>
          <Alert />
        </div>
        <span className='reschedule-reasons-banner-text'>
          {t('jobs.jobReschedule.form.reschedule-reasons-banner-text')}
        </span>
      </div>
    )

    const emptyReasonsMessage = (
      <div className='empty-reasons-message'>
        <img src='/error.png' alt='error' />
        <p className='empty-reasons-message-description'>{t('jobs.jobReschedule.form.reschedule-reasons-empty')}</p>
      </div>
    )

    const addReasons = (_reasons) => {
      return (
        <React.Fragment>
          <div className='reschedule-reasons-drawer'>
            <React.Fragment>
              {rescheduleReasonsBanner}
              <Title level={4} className='select-reschedule-reason-title'>
                {t('jobs.jobReschedule.form.reschedule-reasons-tittle')}
              </Title>
              {rescheduleReasons.length < 1 ? emptyReasonsMessage : null}
              <Radio.Group>
                <Space direction='vertical'>
                  {rescheduleReasons.map((reason) => {
                    const isReasonEnabled = reason.metadata.enabled

                    if (isReasonEnabled) {
                      return (
                        <Radio value={reason.id} onChange={onChangeReason} className='reschedule-reasons-radio'>
                          {reason.title}
                        </Radio>
                      )
                    }
                    return null
                  })}
                </Space>
              </Radio.Group>
              {isReasonOpen ? (
                <TextArea
                  className='reschedule-reasons-comment-text'
                  rows={4}
                  placeholder={t('jobs.jobReschedule.form.comment')}
                  onChange={onChangeComment}
                  showCount
                  maxLength={200}
                  defaultValue={''}
                />
              ) : null}
              {isReasonOpen && textAreaLength < 5 ? (
                <div className='reason-comment-minimum'>
                  {t('jobs.jobReschedule.form.reschedule-reasons-minimum-comment')}{' '}
                </div>
              ) : null}
            </React.Fragment>
          </div>
        </React.Fragment>
      )
    }

    const getSlots = async (jobId) => {
      const slots = await getSlotsAvailabilityRescheduleDeprecated(jobId)
      if (slots) {
        slots.splice(0, 1)
        setSlots(slots)
      }
    }
    const getSlotsV2 = async (jobId) => {
      let slotsV2
      const data = {
        start: dayjs().toISOString(),
        end: dayjs().add(6, 'day').toISOString()
      }

      try {
        slotsV2 = await getSlotsAvailabilityRescheduleV1(jobId, data)
        setNewStructureSlots(true)
        const mappedExpressSlotsV2 = slotsV2.slots.express.map((slot) => {
          return {
            ...slot,
            id: uuidv4()
          }
        })
        const mappedStaticSlotsV2 = slotsV2.slots.statics.map((slot) => {
          return {
            ...slot,
            id: uuidv4()
          }
        })
        setExpressSlots(mappedExpressSlotsV2)
        setStaticSlots(mappedStaticSlotsV2)
      } catch (error) {
        getSlots(jobId)
      }
    }

    const getReasonsList = async () => {
      setLoading(true)
      const reasons = await getReasons(REASON_PARAMS.RESCHEDULE)
      if (reasons) {
        setRescheduleReasons(reasons)
      }
      setLoading(false)
    }

    useEffect(() => {
      cleanFields()
      if (visible) {
        getSlotsV2(jobId)
        getReasonsList()
      }
    }, [jobId, visible])

    return (
      <Drawer
        className='reschedule-drawer'
        title={t('jobs.jobReschedule.form.title')}
        width={500}
        onClose={closeJobRescheduleDrawer}
        visible={visible}
      >
        {current === 1 ? (
          addReasons(rescheduleReasons)
        ) : (
          <div>
            <Steps progressDot current={current}>
              {steps.map((item) => (
                <Step key={item.description} description={item.description} />
              ))}
            </Steps>
            <div className='steps-content'>
              {steps[current].content === 'delivery-content' && listSlotDeliveryTime()}
              {steps[current].content === 'comment-content'}
            </div>
          </div>
        )}

        {current === 0 &&
          validateOperationModelForResetSteps(job.operationModel) &&
          validateStepsForResetSteps(job.tasks) && (
            <div className='reset-steps-checkbox'>
              <Checkbox onChange={() => onChangeCheckBox()} checked={resetSteps} defaultChecked={false}>
                <b className='reset-steps-checkbox-main-text'>
                  {t('jobs.jobReschedule.form.reset-delivery-main-text')}
                </b>{' '}
                <br />
                <span className='reset-steps-checkbox-subtext'>
                  {t('jobs.jobReschedule.form.reset-delivery-subtext')}
                </span>
              </Checkbox>
            </div>
          )}
        <Divider />
        <div className='steps-action-reschedule'>
          {current === 0 && (
            <Button className='steps-action-reschedule-cancel' type='secondary' onClick={handleJobReschedule}>
              {t('jobs.jobReschedule.form.btn-cancel')}
            </Button>
          )}
          {current > 0 && (
            <Button className='rch-btn' onClick={() => prev()}>
              {t('jobs.jobReschedule.form.btn-previous')}
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button type='primary' onClick={next} disabled={isNextDisabled(steps[current].content)}>
              {t('jobs.jobReschedule.form.btn-next')}
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              loading={loading}
              type='primary'
              onClick={() => sendReschedule()}
              disabled={isNextDisabled(steps[current].content)}
            >
              {t('jobs.jobReschedule.form.btn-create')}
            </Button>
          )}
        </div>
      </Drawer>
    )
  }
)

export default JobReschedule
